export const CapitolIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    viewBox='0 0 44 44'
    fill='#334155'
  >
    <rect width='44' height='44' rx='8' fill='#334155' />
    <path
      d='M25.018 20.4722L29.9565 15.2999L28.9264 14.2249L22.9559 18.3165L21.5 11H20.0441V19.5044C20.0441 20.038 19.6313 20.4722 19.12 20.4722H11V21.9971L17.9857 23.5239L13.0453 28.7001L14.0792 29.7751L20.0478 25.6835L21.5037 33H22.9596V24.4917C22.9596 23.9581 23.3743 23.5239 23.8837 23.5239H32V21.9971L25.018 20.4722Z'
      fill='white'
    />
  </svg>
);
